const primary = "#6E43DB";
const secondary = "#000";
const info = "#E86B3C";//before #2866B1
const backgroundColor = "#FBFCFC";
const textLight = '#000';
const primaryLight = '#C9C6E1';
const error = '#D10000';
const success = '#31C90D';
const warning = '#568FFF';
const action = '#D2D2D2';

export {
    primary,
    secondary,
    info,
    backgroundColor,
    textLight,
    primaryLight,
    warning,
    success,
    error,
    action
}
